import { ThemeExposure } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDocumentSections } from '~/react-query-hooks/documents/useDocumentsEntity';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { CitationsAccordionWidget } from '~/widgets/citations-accordion-widget/CitationsAccordionWidget';

import * as Shared from '../../ThemeExposureTab.styles';

interface SourceEvidenceSectionProps {
  themeData: ThemeExposure;
}

export const SourceEvidenceSection = ({
  themeData,
}: SourceEvidenceSectionProps) => {
  const { t } = useTranslation(['widget']);
  const { evidence, source_evidence: sourceEvidence } = themeData.relationship;

  const { data, isFetching, isError } = useDocumentSections(evidence ?? []);

  const getContent = () => {
    if (isFetching) {
      return <Shared.LoadingSkeleton data-testid="loading-skeleton" />;
    } else {
      return (
        <>
          {sourceEvidence && (
            <Shared.BodySmall data-testid="evidence">
              {sourceEvidence}
            </Shared.BodySmall>
          )}
          <CitationsAccordionWidget
            citations={data}
            trackingMetadata={{
              source: POSTHOG_TRACKING_SOURCES.THEME_TO_COMPANY_DRAWER,
            }}
          />
        </>
      );
    }
  };

  if (isError) {
    throw new Error('SourceEvidenceSection error');
  }

  if (!sourceEvidence && !data.length) {
    return null;
  }

  return (
    <Shared.SectionRow>
      <Shared.TitleBase>
        {t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.sourceEvidence'
        )}
      </Shared.TitleBase>
      {getContent()}
    </Shared.SectionRow>
  );
};
